import React, { useEffect, useState } from 'react'
import { ContentCreator, ContentCreatorProperties } from 'models'
import { BuildForm, BuildFormArgs } from 'features/build-form'
import utils from 'features/contentCreator/contentCreator-util'
import validations from 'features/contentCreator/contentCreator-validation'
import * as modelProps from 'models/contentCreator/contentCreator-property-definitions';

export interface ContentCreatorProps {
    BuildList?: (
        page: any,
        name: ContentCreatorProperties,
        form: ContentCreator,
    ) => JSX.Element[]
    page?: any
    title?: any
    form?: ContentCreator
    onUpdate?: (form: ContentCreator, valid: boolean, dirty: boolean) => void
    clear?: (callback: () => void) => void
    context?: any
}
export default function ContentCreatorForm(props: ContentCreatorProps) {
    let [form, setForm] = useState({} as ContentCreator)
    let [dirty, setDirty] = useState({} as any)
    let [hasPosted, setHasPosted] = useState({} as any)
    let [changed, setChanged] = useState(false)
    if (props.clear) {
        props.clear(() => {
            if (changed) {
                setForm({} as ContentCreator)
                setDirty({})
                setHasPosted({})
                setChanged(false)
            }
        })
    }

    useEffect(() => {
        if (changed) {
            setForm({} as ContentCreator)
            setDirty({})
            setHasPosted({})
            setChanged(false)
        }
    }, [props?.context?.id])

    let temp: any = { ...(props.form || {}), ...(form || {}) }
    let args: BuildFormArgs<ContentCreator, ContentCreatorProperties> | any = {
        ...utils,
        form: temp,
        context: props.context,
        utilValidations: validations,
        page: props.page,
        BuildList: (page, name: ContentCreatorProperties, form: ContentCreator) => {
            if (props && props.BuildList) {
                return props.BuildList(page, name, form)
            }
            return []
        },
        GetPageProperties: () => {
            let properties = utils.GetPageProperties();
            return properties.filter(x => ![
                modelProps.ContentCreatorProperties.Id,
                modelProps.ContentCreatorProperties.Deleted,
                modelProps.ContentCreatorProperties.Version,
                modelProps.ContentCreatorProperties.Created,
                modelProps.ContentCreatorProperties.Updated,
                modelProps.ContentCreatorProperties.Owner,
                modelProps.ContentCreatorProperties.Description,
                modelProps.ContentCreatorProperties.ContentHouseId
            ].includes(x.name))
        },
        setForm: (
            form: ContentCreator,
            property: ContentCreatorProperties,
            formValid: boolean,
            updates?: any,
        ) => {
            let newDirty = { ...dirty }
            if (property) {
                newDirty = { ...dirty, [property]: true }
            }
            if (updates) {
                Object.keys(updates).forEach((property) => {
                    newDirty = { ...newDirty, ...dirty, [property]: true }
                })
            }
            setDirty(newDirty)
            let updatedForm: any = {}
            for (let i in newDirty) {
                updatedForm[i] = (form as any)[i]
            }
            setChanged(true)
            setForm(updatedForm)
            if (props.onUpdate) {
                props.onUpdate(
                    { ...(props.form || {}), ...updatedForm },
                    formValid,
                    newDirty,
                )
            }
        },
        isDirty: (property: ContentCreatorProperties) => {
            return dirty[property]
        },
        hasPosted: () => hasPosted,
    }
    return (
        <React.Fragment>
            {BuildForm<ContentCreator, ContentCreatorProperties>(args)}
        </React.Fragment>
    )
}
